var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import orderBy from 'lodash/orderBy';
import { FILTER_OPTIONS_EXAM_DATE_RANGE } from 'reports/hesi-ng/constants';
import { getDateRangeFromFilterOption } from 'reports/hesi-ng/helpers';
import { filterTableRecords } from './table.service';
var buildEmptyRowState = function (type) { return ({
    type: type,
    hasData: false,
    checkedKeys: [],
    from: 0,
    to: 0,
    isChecked: false,
    selectedOptionValue: ''
}); };
var buildEmptyRowsState = function (rowsConfig) {
    var rowsState = {};
    rowsConfig.forEach(function (row) {
        rowsState[row.field] = buildEmptyRowState(row.type);
    });
    return rowsState;
};
var buildDefaultHesiNGExamResultFilter = function () {
    return {
        examGroups: [],
        examType: ''
    };
};
var buildDefaultHesiNGExamResultDateFilter = function () {
    var _a = getDateRangeFromFilterOption(FILTER_OPTIONS_EXAM_DATE_RANGE.lastThreeMonths), fromDateUnix = _a.fromDateUnix, toDateUnix = _a.toDateUnix;
    return {
        fromDate: fromDateUnix,
        toDate: toDateUnix,
        selectedDate: FILTER_OPTIONS_EXAM_DATE_RANGE.lastThreeMonths
    };
};
var buildDefaultStudentHesiNGExamResultFilter = function () {
    return {
        examId: 0,
        studentId: 0,
        examGroupId: 0,
        setParamsFromHesiApp: false
    };
};
var onCohortsFilter = function (_a) {
    var data = _a.data, sortField = _a.sortField, direction = _a.direction, filter = _a.filter;
    if (!sortField && !filter) {
        return data;
    }
    var filteredCohorts = __spreadArray([], data, true);
    if (filter) {
        var remappedData = filteredCohorts.map(function (item) { return (__assign(__assign({}, item), { ppnPercentage: Math.round(item.ppnPercentage * 100) })); });
        filteredCohorts = filterTableRecords(remappedData, filter).map(function (item) { return (__assign(__assign({}, item), { ppnPercentage: item.ppnPercentage / 100 })); });
    }
    var validCohorts = filteredCohorts.filter(function (cohort) { return cohort.specialityExamCount > 0 || cohort.exitExamCount > 0; });
    var emptyCohorts = filteredCohorts.filter(function (cohort) { return !cohort.specialityExamCount && !cohort.exitExamCount; });
    return __spreadArray(__spreadArray([], orderBy(validCohorts, [sortField], [direction]), true), emptyCohorts, true);
};
export { buildEmptyRowState, buildEmptyRowsState, buildDefaultHesiNGExamResultFilter, buildDefaultStudentHesiNGExamResultFilter, buildDefaultHesiNGExamResultDateFilter, onCohortsFilter };
